import React from "react";
import DraggableTextElement from "./TextElement/DraggableTextElement";
import DraggableImageElement from "./ImageElement/DraggableImageElement";
import CustomDragLayer from "../../CustomDragLayer";

const PrintArea = ({
  textElements,
  imageElements,
  design,
  layerId,
  bleed,
  disableInteractivity,
  onShow2ndTip,
  didShow2ndTip,
  handleHide2ndTip,
  handleIsDragging,
  isDraggingSelected,
  guidesVisible,
  allowImage,
  allowPhoto,
  allowText
}) => {
  const textElementsCount = textElements.length;

  // Find the current layer based on layerId
  const layer = design.layer_set.find((layer) => layer.layer_id === layerId);

  const elements = [];
  imageElements.forEach((imageElement, index) => {
    elements.push(
      <DraggableImageElement
        key={`image-${layerId}-${index}-${imageElement.id || index}`}
        layerId={layerId}
        index={index}
        imageElement={imageElement}
        design={design}
        guidesVisible={guidesVisible}
        disableInteractivity={disableInteractivity}
        onShow2ndTip={onShow2ndTip}
        didShow2ndTip={didShow2ndTip}
        handleHide2ndTip={handleHide2ndTip}
        handleIsDragging={handleIsDragging}
        isDraggingSelected={isDraggingSelected}
        layer={layer}
      />
    );
  });

  textElements.forEach((textElement, index) => {
    elements.push(
      <DraggableTextElement
        key={`text-${layerId}-${index}-${textElement.id || index}`}
        layerId={layerId}
        index={index}
        textElement={textElement}
        design={design}
        guidesVisible={guidesVisible}
        disableInteractivity={disableInteractivity}
        onShow2ndTip={onShow2ndTip}
        didShow2ndTip={didShow2ndTip}
        handleHide2ndTip={handleHide2ndTip}
        handleIsDragging={handleIsDragging}
        isDraggingSelected={isDraggingSelected}
        textElementsCount={textElementsCount}
        layer={layer}
      />
    );
  });

  return allowImage || allowPhoto || allowText ? (
    <div className="print__container">
      {bleed.bleed && bleed.bleedSide === "left" && (
        <div className="bleed bleed--left" />
      )}

      <div className="print__area">
        {elements}
        <CustomDragLayer layerId={layerId} />
      </div>

      {bleed.bleed && bleed.bleedSide === "right" && (
        <div className="bleed bleed--right" />
      )}
    </div>
  ) : null;
};

export default PrintArea;
